<template>
  <div class="data-view-detail-container">
    <template v-if="currentItem">
      <div
        class="condition"
        v-show="isCanAdd"
      >
        <i class="icon jlxk-data-view-alter" /><router-link :to="alterURL">
          修改
        </router-link>
      </div>
      <ul :class="['detail-container', { conditon_border: !isCanAdd }]">
        <li
          v-for="(item, index) in fieldArr"
          :key="index"
          v-show="handleField(index)"
        >
          <label>{{ handleLable(item, index) }}：</label><span v-html="handleTagValue(index)" />
        </li>
      </ul>
    </template>
    <div
      class="emtpy"
      v-else
    >
      当前未查询到任何数据
    </div>
  </div>
</template>

<script>
import jlxkAPIS from '@apis/jlxk'
export default {
  name: 'Tag',
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    topDataCode: {
      type: String,
      default: ''
    },
    isCanAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nationList: [],
      fieldArr: {
        categoryName: '数据分类',
        zzsrc: '信息来源',
        pubdate: '发布时间',
        author: '作者',
        description: '摘要',
        topCategory: '领域',
        contentAttribute: '内容属性',
        isSensitive: '是否敏感',
        region: '地域',
        involvePerson: '涉及人物',
        theme: '主题',
        keyWords: '关键词',
        department: '录入单位',
        created: '上传时间',
        isAppraise: '情感',
        hasPic: '图片张数',
        publisher: '出版单位',
        location: '稿件url',
        totalEpisodeNumber: '总集数',
        episodeNumber: '集数',
        nation: '民族'
      }
    }
  },
  computed: {
    currentIndex() {
      return this.$store.state.currentIndex
    },
    alterURL() {
      if (!this.currentItem) return '/jlxk/editor'
      return {
        path: '/jlxk/editor',
        query: {
          modelId: this.currentIndex,
          topId: this.currentItem.topDataCategoryId,
          secId: this.currentItem.secDataCategoryId,
          id: this.currentItem.id
        }
      }
    },
    isImageText() {
      return (
        this.currentItem.articletypeid &&
        String(this.currentItem.articletypeid) === '1'
      )
    },
    isAtlas() {
      return (
        this.currentItem.articletypeid &&
        String(this.currentItem.articletypeid) === '2'
      )
    },
    isAudio() {
      return (
        this.currentItem.articletypeid &&
        String(this.currentItem.articletypeid) === '6'
      )
    },
    isVideo() {
      return (
        this.currentItem.articletypeid &&
        String(this.currentItem.articletypeid) === '5'
      )
    },
    isBooksFile() {
      return (
        this.currentItem.articletypeid &&
        String(this.currentItem.articletypeid) === '3'
      )
    },
    isFilmWoks() {
      return (
        this.currentItem.articletypeid &&
        String(this.currentItem.articletypeid) === '4'
      )
    }
  },
  created() {
    this.getNationList()
  },
  mounted() {},
  methods: {
    // 民族列表
    async getNationList() {
      let { status, data } = await jlxkAPIS.postNationList()
      if (status === 0 && data && data.length !== 0) {
        this.nationList = data.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })
      } else {
        this.nationList = []
      }
    },
    handleAppraise(value) {
      if (value === 0) return '中性'
      else if (value === 1) return '正面'
      else return '负面'
    },
    handleField(value) {
      if (value === 'isAppraise' || value === 'keyWords') {
        return this.isImageText
      } else if (value === 'hasPic') return this.isAtlas
      else if (value === 'location') return !this.isAtlas && !this.isFilmWoks
      else if (value === 'publisher') return this.isBooksFile
      else if (value === 'totalEpisodeNumber' || value === 'episodeNumber') {
        return this.isFilmWoks
      } else if (value === 'nation') {
        let topDataCode = this.$parent.$parent.$parent.topDataCode
        let codeArr = [
          'ZYLDTZXGZL',
          'DSJ',
          'NJSJ',
          'LLWZZZSJ',
          'XWBDSJ',
          'DXRWSJ',
          'KTBDSJ',
          'ZTPSJ',
          'CBWSJ',
          'WYZPSJ',
          'ZDGCSJ',
          'GRZPSJ',
          'TJSJ'
        ]
        return codeArr.indexOf(topDataCode) !== -1
      } else if (value === 'contentAttribute') {
        let topDataCode = this.$parent.$parent.$parent.topDataCode
        let codeArr = ['DXRWSJ', 'DY']
        return codeArr.indexOf(topDataCode) !== -1
      }
      return true
    },
    handleTagValue(index) {
      if (index === 'isAppraise') {
        return this.handleAppraise(this.currentItem[index])
      }
      if (index === 'contentAttribute') {
        let topDataCode = this.$parent.$parent.$parent.topDataCode
        return this.currentItem[index] || (topDataCode === 'DXRWSJ' ? '人物报道' : '电影简介')
      }
      if (index === 'pubdate') { return this.currentItem[index].slice(0, 10) }
      if (index === 'nation') {
        let curItem = this.nationList.filter(item => String(item.id) === String(this.currentItem[index]))
        return curItem.length !== 0 ? curItem[0].name : ''
      }
      return this.currentItem[index]
    },
    handleLable(item, index) {
      if (index === 'location') {
        if (this.isImageText) return '稿件url'
        else if (this.isBooksFile) return '书籍文件URL'
        else if (this.isAudio) return '音频URL'
        return '视频URL'
      }
      if (index === 'pubdate') {
        if (this.topDataCode === 'ZTPSJ') return '上映时间'
        else if (this.isBooksFile || this.isFilmWoks) return '发行时间'
        else return item
      }
      if (index === 'author') {
        if (this.isFilmWoks && this.topDataCode === 'WYZPSJ') {
          return '主演/主唱'
        } else if (this.isFilmWoks) return '导演'
        else return item
      }
      if (index === 'involvePerson' && this.topDataCode === 'ZYLDTZXGZL') {
        return '领导人'
      }
      return item
    }
  }
}
</script>

<style lang="scss" scoped>
.data-view-detail-container {
  .condition {
    display: flex;
    align-items: center;
    position: relative;
    height: 48px;
    background: #edf0f7;
    padding-left: 30px;
    &::before {
      position: absolute;
      left: 0;
      top: 17px;
      content: "";
      width: 4px;
      height: 15px;
      background: rgba(234, 85, 33, 1);
      border-radius: 2px;
    }
    a {
      margin-left: 4px;
      font-size: 13px;
      color: #0499f3;
    }
  }
}
.detail-container {
  padding: 15px 20px 15px 30px;
  li {
    position: relative;
    color: #333333;
    font-size: 14px;
    padding-left: 18px;
    // height: 32px;
    line-height: 32px;
    word-break: break-all;
    &::before {
      position: absolute;
      left: 0;
      top: 13px;
      width: 4px;
      height: 4px;
      background: #4497ec;
      border-radius: 50%;
      content: "";
    }
    label {
      display: inline-block;
      min-width: 70px;
      max-width: 94px;
      flex-shrink: 0;
    }
    /deep/ em{
      font-style:normal;
    }
  }
}
.emtpy {
  text-align: center;
  padding: 50px 0;
  font-size: 13px;
  color: #666;
}
</style>
